import { fixImageUrl } from 'component/Image/util'
import { useLatestCallback } from 'hook/useLatestCallback'
import { useState } from 'react'

export type PreviewControl = {
  setPreview(source: string | undefined): void
  preview: string | undefined
}

export const usePreviewControl = (): PreviewControl => {
  const [preview, setPreviewRaw] = useState<string | undefined>(undefined)

  const setPreview = useLatestCallback((source: string | undefined) => {
    setPreviewRaw(fixImageUrl(source))
  })

  return { preview, setPreview }
}
